import gql from "graphql-tag";

export const paymentTypeFragment = gql`
  fragment paymentTypeFragment on PaymentType {
    payment_type_id
    type
    description
  }
`;
